







































import { Vue, Component } from 'vue-property-decorator'
import { Step1, Step2, Step3, Step4 } from './components'
import { WingBlank, MainHead, BtnFooter, ExplainFooter } from '@/components/index'
import { PlanAdd, PlanConfigTrigger, PlanWebhookAdd, PlanUpdata } from '@/api/plainAdmin'
import { WebhookDel, WebhookUpdata } from '@/api/Webhook'
import { WebhookUpdataForm } from '@/types/Webhook'
import { PlanUpdataForm } from '@/types/PlanAdmin'
import { cusElForm } from '@/types/form'
@Component({
  components: {
    WingBlank,
    MainHead,
    BtnFooter,
    Step1,
    Step2,
    Step3,
    Step4,
    ExplainFooter
  }
})
export default class Create extends Vue {
  // 头部数据
  headData: string[] = ['过配置触发条件和执行器创建智能运营计划。']
  headTitle: string = '创建运营计划'
  stepNumber: number = 1
  // 页脚说明
   explainFooter: string[] = ['文件：选择系统配置中创建的文件数据源。', '1、根据文件数据源创建的分群，仅对文件中object_id字段进行处理。']
   /**
    * 步骤form
    */
   step1Form:any = {}
   step2Form:any = {}
   step3Form:any = []
   step4Form:any = {}
   // 下一步，步骤加一
   async handleStep(direction: string) {
     const { stepNumber } = this
     if (direction === 'left') {
       stepNumber === 1 ? (this as any).$router.go(-1) : this.stepNumber--
     } else {
       if (stepNumber === 4) {
         await this.handleSubmitAll()
         this.$router.push('/operate/planning')
         // 走你
       } else {
         (this.$refs[`step${stepNumber}`] as cusElForm).vaildSubmit((status:boolean, val:any) => {
           if (status) {
             (this as any)[`step${stepNumber}Form`] = val
             this.stepNumber++
             if (stepNumber === 3) {
               const { step1Form, step2Form, step3Form } = this
               this.step4Form = {
                 name: step1Form.name,
                 code: step1Form.code,
                 objectName: step1Form.objectName, // step1Form.objectName,
                 groupName: step1Form.categoryArr.find((item:any) => item.id === step1Form.categoryId).name,
                 description: step1Form.description,
                 implement: step3Form.tableData
               }
             }
           }
         })
       }
     }
   }
   /**
    * 提交
    *
    * 接口
    * PlanAdd, PlanConfigTrigger,PlanWebhookAdd
    */
   async handleSubmitAll() {
     const { type, } = this.$route.query
     const formObj = this.$route.query.formObj
     const id = (formObj && (formObj as any).id) || ''

     const { step1Form, step2Form, step3Form } = this
     // 处理 步骤一
     const _form = JSON.parse(JSON.stringify(step1Form))
     _form.planCategoryId = _form.categoryId
     _form.triggerType = step2Form.triggerType
     _form.cron = step2Form.cron
     delete _form.categoryId
     delete _form.categoryArr
     delete _form.objectName

     if (type === 'add') {
       await PlanAdd(_form)
     } else {
       _form.id = id
       let _str = '?'
       for (const k in _form) {
         _str += `${k}=${_form[k]}&`
       }
       const str = _str.slice(0, _str.length - 1)
       PlanUpdata(str)
     }

     const _step2Form = JSON.parse(JSON.stringify(step2Form))
     delete _step2Form.singleTime
     delete _step2Form.grouping
     delete _step2Form.groupingArr

     await PlanConfigTrigger((_step2Form as any).groupIds, (_form as any).objectId, (_step2Form as any).cron, (_step2Form as any).triggerType)

     step3Form.tableClientData.length > 0 && step3Form.tableClientData.forEach((item:any) => {
       if (item.clientType) {
         if (item.clientType === 'del') {
           // 删除 webhooks
           WebhookDel(item.id)
         } else if (item.clientType === 'edit') {
           // 编辑
           if (item.id.toString().indexOf('client')) {
             // add
             const params:WebhookUpdataForm = {
               // eslint-disable-next-line key-spacing
               planId:_form.objectId,
               name: item.name,
               status: item.status ? 1 : 2,
               webhookId: item.ids,
               webhookParam: JSON.stringify([...item.webhookParamMap.custom, ...item.webhookParamMap.preinstall])
             }
             PlanWebhookAdd(params)
           } else {
             // edit
             const params:WebhookUpdataForm = {
               // eslint-disable-next-line key-spacing
               planId:_form.objectId,
               id: item.id,
               name: item.name,
               status: item.status ? 1 : 2,
               webhookId: item.ids,
               webhookParam: JSON.stringify([...item.webhookParamMap.custom, ...item.webhookParamMap.preinstall])
             }
             WebhookUpdata(params)
           }
         }
       } else {
         // add
         const params:WebhookUpdataForm = {
           // eslint-disable-next-line key-spacing
           planId:_form.objectId,
           name: item.name,
           status: item.status ? 1 : 2,
           webhookId: item.ids,
           webhookParam: JSON.stringify([...item.webhookParamMap.custom, ...item.webhookParamMap.preinstall])
         }
         PlanWebhookAdd(params)
       }
     })
   }
}
